<template>
  <li href="#drawer-messages-chat" class="dashboard-thread-list-item" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-messages-chat" @click="handleGetThreadCallback">
    <a>
      <div class="row">
        <div class="col-xs-12 col-sm-1 participants-container">
          <img v-for="(p, index) in participantsAvatars" :key="p.id" :src="p.avatar" :style="{left: (index * 15) + 'px', 'z-index': participantsAvatars.length - index }">
        </div>
        <div class="col-xs-12 col-sm-10 col-md-6">
          <h3 class="chat-lead">
            {{ booking.name }}
          </h3>
          <div class="chat-sub participants">{{ participantsNames }}</div>
          <span v-if="thread.latest_message">
            <span :class="this.thread.unread_count ? 'unread-messages' : 'chat-sub message-text'">
              {{ messageName }}: {{ thread.latest_message.type === 'file' ? 'File Uploaded' : thread.latest_message.text }}
            </span>
            <span class="pull-right" :class="this.thread.unread_count ? 'unread-messages' : 'chat-sub message-text'">
              {{ messageTimestamp }}
              <span v-if="this.thread.unread_count && !$userIsAdmin" class="unread-circle pull-right">
                &nbsp;
              </span>
              <span v-if="this.thread.unread_count && $userIsAdmin" class="pull-right">
                &nbsp;| {{ this.thread.unread_count}} unread
              </span>
            </span>
          </span>
          <span v-else>
            <span class="chat-sub message-text">No Messages</span>
          </span>
        </div>
        <div class="hidden-xs hidden-sm col-md-4 details-panel">
          <p>
            <span class="label label-danger" v-if="bookingIsContextuallyCancelled">Cancelled</span>
            <span class="label label-success" v-else-if="bookingIsScheduled">Scheduled</span>
            <span class="label label-info" v-else-if="bookingIsOnHold">On Hold</span>
            <span class="label label-success" v-else-if="bookingIsBooked">Booked</span>
            <span class="label label-success" v-else-if="bookingIsCompleted">Completed</span>
            <span class="label-hidden" v-if="$userIsAdmin && bookingIsNotPublic">Hidden</span>
            <span class="label label-danger" v-if="$paymentsModuleEnabled && bookingBookedDepositUnpaid">Deposit Unpaid</span>
            <span class="label label-danger" v-if="$paymentsModuleEnabled && bookingBookedDepositSent">Deposit Sent</span>
          </p>
          <p>
            <span v-if="$userIsTalent || $userIsManager">
              {{ booking.budget_per_star_as_user_rate | currency(booking.currency) | nullable }}
              <span v-if="$userIsManager">
                /{{ $starLabel }}
              </span>
            </span>
            <span v-else>
              {{ booking.budget_per_star | currency(booking.currency) }}
              <span v-if="$userIsAdmin">
                ({{ booking.budget_per_star_as_user_rate | currency(booking.currency) }})
              </span>
              /{{ $starLabel }}
            </span>
          </p>
          <div class="row" v-if="$userIsAdmin && $paymentsModuleEnabled">
            <div class="col-xs-6">
              <p v-if="bookingAppearanceInPerson"><i class="fa fa-calendar fa-fw"></i> {{ booking.tz_date | dateTimezone(booking.timezone, $user.date_format_preference) | nullable }}</p>
              <p v-else><i class="fa fa-calendar fa-fw"></i> &ndash;</p>
              <p><i class="fa fa-globe fa-fw"></i> {{ bookingStateOrOnline }}</p>
            </div>
            <div class="col-xs-6">
              <p v-if="$userIsAdmin">Booking ID: {{ booking.id }}</p>
              <p v-if="booking.payments && booking.payments.length > 0">
                <span style="text-transform: capitalize" v-for="payment in booking.payments" :key="payment.id">{{ payment.type }}: {{payment.status }},</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import { helpers } from 'mixins/messages'
import { helpers as bookingHelpers } from 'mixins/bookings'
import { mapActions, mapState } from 'vuex'

export default {
  mixins: [helpers, bookingHelpers],

  props: {
    thread: {
      required: true,
      type: Object
    },
    booking: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapState('clientConfig', ['client_config'])
  },

  methods: {
    ...mapActions('message', ['getThread']),
    ...mapActions('dashboard', ['dashboardThreadUnreadCount']),

    handleGetThreadCallback () {
      const targetElement = document.getElementById('mainbody')
      targetElement.style.overflow = 'hidden'
      return this.getThread({threadId: this.thread.id, userId: this.$user.id, tenantSlug: this.client_config.slug, getFiles: true}).then(() => {
        this.dashboardThreadUnreadCount(this.thread.id)
      })
    }
  }
}
</script>
